import { render, staticRenderFns } from "./question-viewer.vue?vue&type=template&id=40b1016f&scoped=true"
import script from "./question-viewer.ts?vue&type=script&lang=ts&external"
export * from "./question-viewer.ts?vue&type=script&lang=ts&external"
import style0 from "./question-viewer.scss?vue&type=style&index=0&id=40b1016f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1016f",
  null
  
)

export default component.exports